import React, { useState, useEffect, useCallback } from "react";
import './queries.css'
import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import FixingRates from "../fixing-rates"
import { AxiosResponse } from "axios";
import api from "../../data/api";

const Queries: React.FC = () => {
    // reset the rejected state, so it can be displayed again
    // this state change should not affect this compoennt
    const rootDispatch = useDispatch()    

    const[fxRates, setFXRates] = useState<{ currRateBuy: string, currRateSell: string, currCode: string, inpDate: string}[]>([]);
    //const[usdFxRates, setUsdFxRates] = useState<{ currCode: string, inpDate: string}[]>([]);
    const[fixingRateClick, setfixingRateClick] = useState(0);

    useEffect(() => {
        document.title = "Codelist"        
        //reset the search history which stores the latest search criteria
        rootDispatch({ type: "ResetHistory" })
        
        // returning the dispatch to avoid unneccessary rerender
        return (() => {
            rootDispatch({ type: "App/DISCLAIMERRESET" })
            rootDispatch({ type: "CCB/RESETSEARCH" })
            rootDispatch({ type: "Ismag/RESETSEARCH" })            
        })
    })

    useEffect(() => {
        if (fixingRateClick > 0) {
            const fxRatesDate =  fxRates.length > 0 ? "on " + fxRates[0].inpDate : ""
            rootDispatch({ type: "App/EXTWINDOWOPEN", content: <FixingRates locationURL={window.location.protocol + "//" + window.location.hostname + ":" + window.location.port} fxRates={fxRates} baseCurrency = 'EUR' />
            , windowTitle: "EURO Fixing Rates for Customer FX Instructions " + fxRatesDate })
        }
    }, [fxRates])

/*
    useEffect(() => {
        if (fixingRateClick > 0) {
            const fxRatesDate =  usdFxRates.length > 0 ? "on " + usdFxRates[0].inpDate : ""
            rootDispatch({ type: "App/EXTWINDOWOPEN", content: <FixingRates locationURL={window.location.protocol + "//" + window.location.hostname + ":" + window.location.port} fxRates={usdFxRates} baseCurrency = 'USD'/>
            , windowTitle: "USD Fixing Rates for Customer FX Instructions " + fxRatesDate })
        }
    }, [usdFxRates])
*/
    const handleFixingRates = useCallback(() => {                
        setfixingRateClick(fixingRateClick + 1 );
        
        api.post( "/codelist/v1/eurofixingrates/search" ) 
           .then( (response:AxiosResponse) => { setFXRates(response.data.euroFixingRates) }
            ).catch( (error) => {
                setFXRates([]);
                console.log("An error occurred while retrieving the data.")
            })
            
    }, [])

    // const handleUSDFixingRates = useCallback(() => {                
    //     setfixingRateClick(fixingRateClick + 1 );
    //     api.post( "/codelist/v1/usdfixingrates/search" ) 
    //        .then( (response:AxiosResponse) => { setUsdFxRates(response.data.usdFixingRates) } )
    // }, [])

    return (
        <div id="content">
            <p className="premium-disclaimer">
                    Please be informed that access to the Securities Database is restricted to Premium Users only.
				<br />
				    If you have not already done so, please register on the <a href="https://www.clearstream.com">Clearstream website</a>.
				<br />
				    For internal user, please pre-register on IdentityIQ before proceeding.
				<br />
                <br />
				    For further information, please contact the website helpdesk on <a href="mailto:web@clearstream.com">web@clearstream.com</a> or Clearstream Client Services.
			</p>
            <ul className="index-list">
                {/**
                <a href="/codelist/security/#/logindocument">Corporate Actions Documents Database </a>            
                
                <p className="premium-link-info">&nbsp;(Premium Users only - login required)</p>                
                */}
                <li><Link to="/ccb">Cash Correspondents Database</Link></li>
                <li><Link to="/depocriteria">Depositories Database</Link></li>
                <a href="/codelist/security/#/loginsecurity">Securities Database </a>            
                <p className="premium-link-info">&nbsp;(Premium Users only - login required)</p>
                <li>
                    <div className="navigation" onClick={handleFixingRates} >
                        EURO Fixing Rates for Customer FX Instructions
                    </div>
                </li>
                {/* Commented out as no confirmation has been received for delivery
                <li>
                    <div className="navigation" onClick={handleUSDFixingRates} >
                        USD Fixing Rates for Customer FX Instructions
                    </div>
                </li>                
                 */}
                <li><Link to="/ismag">Issuer ISMAG Adherence</Link></li>                
            </ul>
        </div>
    )
}

export default Queries